<template>
  <px-custom-dialog v-model="dialog" content-class="rounded-card"
                    :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Compra
      <v-btn class="ml-3" icon link target="_blank" :to="linkCompra">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <px-compra-detalhes is-modal-view
                          :show-entregas="showEntregas"
                          :compra-id-prop="compraId"/>
    </template>
  </px-custom-dialog>
</template>

<script>
export default {
  props: {
    compraId: {
      type: [String, Number],
    },
    showEntregas: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    linkCompra() {
      return `/compra/${this.compraId}/detalhes`;
    },
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '1400px';
    },
  },
  components: {
    pxCompraDetalhes: () => import('@/modules/compra/detalhes/CompraDetalhes.vue'),
  },
};
</script>
